class videoHelper {
    constructor(el) {
    }

    listen(el) {

        el.addEventListener('mouseenter', () => {
            el.getElementsByTagName("video")[0].play();
        });

        el.addEventListener('mouseleave', () => {
            el.getElementsByTagName("video")[0].pause();
        });
    }


    pauseVideoLoop() {
        $('#pauseLoop').on('click', function () {
            $('.hero-video').hide();
            $('#pauseLoop').hide();
            $('#playLoop').show();
        });
    }

    playVideoLoop() {
        $('#playLoop').on('click', function () {
            $('.hero-video').show();
            $('#pauseLoop').show();
            $('#playLoop').hide();
        });
    }

}

window.app.add('video', new videoHelper());